module.exports = __webpack_public_path__ + "static/img/2222.637669b2.jpg";